import ROUTES from 'shared/constants/routes';
import CONFIG from 'shared/constants/config';

export const navData = [
  {
    id: 1,
    url: ROUTES.START.ROUTE,
    name: ROUTES.START.NAME,
    icon: 'icon_magic',
    disabled: false,
  },
  {
    id: 2,
    url: ROUTES.LEADERS.ROUTE,
    name: ROUTES.LEADERS.NAME,
    icon: 'icon_barchart',
    disabled: false,
  },
  {
    id: 3,
    url: ROUTES.FRIENDS.ROUTE,
    name: ROUTES.FRIENDS.NAME,
    icon: 'icon_heart',
    disabled: false,
  },
  {
    id: 4,
    url: ROUTES.SHOP.ROUTE,
    name: ROUTES.SHOP.NAME,
    icon: 'icon_cart',
    disabled: false,
  },
  {
    id: 5,
    url: ROUTES.PROFILE.ROUTE,
    name: 'Выход',
    icon: 'icon_undo',
    disabled: false,
  },
  // {
  //   id: 5,
  //   url: ROUTES.PROFILE.ROUTE,
  //   name: ROUTES.PROFILE.NAME,
  //   icon: 'icon_user',
  //   disabled: false,
  // },
  // {
  //   id: 5,
  //   url: ROUTES.SETTINGS.ROUTE,
  //   name: ROUTES.SETTINGS.NAME,
  //   icon: 'icon_regulator',
  //   disabled: false,
  // },
];

export const navDataApp = [
  {
    id: 11,
    url: ROUTES.TESTS.ROUTE,
    name: ROUTES.TESTS.NAME,
    icon: 'icon_list-unordered',
    disabled: false,
  },
  // {
  //   id: 12,
  //   url: ROUTES.TASKS.ROUTE,
  //   name: ROUTES.TASKS.NAME,
  //   icon: 'icon_star-outline',
  //   disabled: true,
  //   hidden: !CONFIG.IS_DEV,
  // },
  {
    id: 13,
    url: ROUTES.START.ROUTE,
    name: ROUTES.GAMES.NAME,
    icon: 'icon_magic',
    disabled: false,
    hidden: !CONFIG.IS_DEV,
  },
  {
    id: 14,
    url: ROUTES.PROFILE.ROUTE,
    name: ROUTES.PROFILE.NAME,
    icon: 'icon_user',
    disabled: false,
  },
  {
    id: 16,
    url: ROUTES.BALANCE.ROUTE,
    name: ROUTES.BALANCE.NAME,
    icon: 'icon_card',
    disabled: false,
  },
  {
    id: 15,
    url: ROUTES.MORE.ROUTE,
    name: ROUTES.MORE.NAME,
    icon: 'icon_options',
    disabled: false,
    hidden: !CONFIG.IS_DEV,
  },
];
